__turbopack_context__.v({
  "appBanner_button": "app-banner-module-scss-module__1DbtYq__appBanner_button",
  "appBanner_close": "app-banner-module-scss-module__1DbtYq__appBanner_close",
  "appBanner_closeIcon": "app-banner-module-scss-module__1DbtYq__appBanner_closeIcon",
  "appBanner_container": "app-banner-module-scss-module__1DbtYq__appBanner_container",
  "appBanner_content": "app-banner-module-scss-module__1DbtYq__appBanner_content",
  "appBanner_image": "app-banner-module-scss-module__1DbtYq__appBanner_image",
  "appBanner_imageContainer": "app-banner-module-scss-module__1DbtYq__appBanner_imageContainer",
  "appBanner_info": "app-banner-module-scss-module__1DbtYq__appBanner_info",
  "app_download": "app-banner-module-scss-module__1DbtYq__app_download",
  "banner_logo": "app-banner-module-scss-module__1DbtYq__banner_logo",
  "banner_text": "app-banner-module-scss-module__1DbtYq__banner_text",
  "banner_title": "app-banner-module-scss-module__1DbtYq__banner_title",
});
